module.exports = __webpack_public_path__ + "static/img_yqhy.fb865bb9.png";